import { Button, Form } from "react-bootstrap";
import BetSlipContext from "../context/BetSlipContext";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import { useContext } from "react";
const PlaceBetNew = ({ onClose }) => {
  const { betSlipObject, setBetSlipObject, handelPlaceBetFairUpdated } =
    useContext(BetSlipContext);
  const { user, profileData } = useContext(AuthContext);
  const placeBet = () => {
    if (!isEmpty(user)) {
      handelPlaceBetFairUpdated();
    }
  };

  return (
    <div className="p-1">
      <div className="d-flex">
        <div className="me-2 input-fix">
          <Form.Label htmlFor="inputPassword5">Odd</Form.Label>
          <Form.Control
            value={betSlipObject?.bhav}
            className="me-2"
            onChange={(e) =>
              setBetSlipObject((prev) => {
                return { ...prev, bhav: e.target.value };
              })
            }
            aria-label="First name"
          />
        </div>
        <div className="input-fix">
          <Form.Label htmlFor="inputPassword5">Stake</Form.Label>
          <Form.Control
            value={betSlipObject?.bidPrice}
            disabled
            type="number"
            className="me-2"
            aria-label="First name"
          />
        </div>
      </div>
      <p className="infoTxt">or Choose Your Stake Size</p>
      <hr className="lgrey" />
      {(profileData?.editOneClickBetStake?.length > 0
        ? profileData?.editOneClickBetStake
        : number
      )?.map((res) => {
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setBetSlipObject({
                ...betSlipObject,
                bhav: isEmpty(betSlipObject?.bhav)
                  ? Number(res)
                  : Number(betSlipObject?.bhav) + Number(res),
              });
            }}
            className="stake-value me-1"
          >
            +{res}
          </span>
        );
      })}
      <hr className="lgrey" />
      <Button
        onClick={() => {
          onClose();
        }}
        variant="primary"
        className="btn-red me-1"
        size="sm"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          placeBet();
        }}
        variant="secondary"
        className="btn-green"
        size="sm"
      >
        Place bid
      </Button>
    </div>
  );
};

export default PlaceBetNew;

const number = [100, 500, 1000, 5000, 10000, 25000, 100000];
